class FloatingLabel extends HTMLElement {
  static observedAttributes = ['validation-message'];

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          position: relative;
          user-select: none;
          padding-bottom: 0.25rem;
        }
        .validation-bar {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background: #000;
        }
      </style>
      <slot></slot>
      <div class="validation-bar"></div>
    `;
  }

  connectedCallback() {
    this.input = this.querySelector('input, select');
    this.label = this.querySelector('label');
    if (this.input && this.label) {
      this.input.addEventListener('change', (e) => {
        if (e.target.value !== '') {
          // deal with auto complete
          this.label.setAttribute('floating', null);
        }
      });
      this.input.addEventListener('focus', () => this.label.setAttribute('floating', null));
      this.input.addEventListener('blur', () => {
        if (this.input.value === '') {
          this.label.removeAttribute('floating');
        }
      });
      if (this.input.value !== '') {
        this.label.setAttribute('floating', null);
      }
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'validation-message') {
      this.shadowRoot.querySelector('.validation-bar').style.background = newValue ? 'red' : 'black';
    }
  }
}

customElements.define('floating-label', FloatingLabel);
